import { useEffect, useState } from 'react'
import { Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'
import RowStack from 'components/atoms/container/RowStack'
import { ColStack } from 'components/atoms/container/InCardStack'
import EastIcon from '@mui/icons-material/East'
import { JOURNEY } from 'routes/constants'
import { getUserCurrentGoal } from 'utils/getSupportingInfo'
import { useNavigate } from 'react-router-dom'

const JumpToGoalButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [currentGoal, setCurrentGoal] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      const goal = await getUserCurrentGoal()
      setCurrentGoal(goal)
    }
    fetchData()
  }, [])

  return (
    <>
      {currentGoal && !currentGoal?.opensAt && (
        <RowStack
          spacing={8}
          sx={{
            borderRadius: 4,
            backgroundColor: colors.MidnightTeal400,
            paddingX: 8,
            paddingY: 4,
            boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.15)',
            width: 'auto',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: colors.MidnightTeal300
            }
          }}
          onClick={() => navigate(JOURNEY)}>
          <ColStack spacing={0}>
            <Typography
              variant='body1KindaSmall'
              color={colors.White}
              fontWeight={700}>
              {t('welcomeArea.jumpBackInto')}
            </Typography>
            <Typography variant='body1Small' color={colors.White}>
              {currentGoal?.name}
            </Typography>
          </ColStack>

          <Button endIcon={<EastIcon />} size='small'>
            {t('welcomeArea.go')}
          </Button>
        </RowStack>
      )}
    </>
  )
}

export default JumpToGoalButton
